angular.module('nv.shared.services.shared-state', []);
